import React, { Component } from 'react';

export default class MaxWidthVideo extends Component {
  render() {
	
    return (
      <div className="max-width-container">
        <video width="100%" height="auto" loop autoPlay muted playsInline poster="images/so-eventful-hero.jpg"><source src={this.props.video} type="video/mp4" /></video>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/maxWidthVideo.js